exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goods_detail .goods_detail_wrapper[data-v-46dc6750]{z-index:200;position:absolute;left:50%;top:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);width:375px;background:#f0f2f5}.goods_detail .goods_detail_wrapper.on[data-v-46dc6750]{position:fixed}", ""]);

// exports
